import Vue from 'vue';
import {
  ValidationProvider, ValidationObserver, extend, configure, /* setInteractionMode */

} from 'vee-validate';
import * as rules from 'vee-validate/dist/rules';

Object.keys(rules).forEach((rule) => {
  extend(rule, rules[rule]);
});

// Add custom rules
// extend('positive', (value) => value >= 0);
extend('cypriot_license_plate', (value) => {
  if (!value.endsWith('000')) {
    return /^[A-Z]{0,3}[0-9]{3}$/g.test(value);
  }
  return false;
});

// setInteractionMode('passive');

const config = {
  // validity: true,
  mode: 'eager',
  classes: {
    invalid: 'is-invalid'
  },
};

configure(config);

// Register it globally
Vue.component('ValidationProvider', ValidationProvider);
Vue.component('ValidationObserver', ValidationObserver);
